'use client'

import { lazy, Suspense } from 'react'

import Icon from '@/legacy-src/components/icons/Icon'
import { useIsTablet } from '@/legacy-src/hooks/useIsTablet'

import { ButtonIcon } from '@/src/domains/design-system/components/Button'
import type { CMSMenuItem } from '@/src/domains/cms-menus/schemas'

const HeaderMobileMenuUI = lazy(() =>
  import('./HeaderMobileMenu.ui').then((mod) => ({ default: mod.HeaderMobileMenuUI })),
)

export interface HeaderMobileMenuProps {
  isBusiness?: boolean
  menu: CMSMenuItem[]
}

export const HeaderMobileMenu = ({ isBusiness = false, menu }: HeaderMobileMenuProps) => {
  const isTablet = useIsTablet()

  return (
    <div className="laptop:hidden">
      {isTablet ? (
        <Suspense
          fallback={
            <ButtonIcon variant="secondary" size="small" disabled>
              <Icon icon="hamburger" />
            </ButtonIcon>
          }
        >
          <HeaderMobileMenuUI isBusiness={isBusiness} menu={menu} />
        </Suspense>
      ) : (
        <ButtonIcon variant="secondary" size="small" disabled>
          <Icon icon="hamburger" />
        </ButtonIcon>
      )}
    </div>
  )
}
